import { classNames } from 'src/utilities';
import { Text } from '../baseComponents';

export const TextField = ({
  type,
  label,
  id,
  className,
  labelClassName,
  inputClassName,
  name,
  placeholder,
  errorMessage,
}) => {
  return (
    <div className={classNames(className ? className : '')}>
      {label ? (
        <Text
          type={'label'}
          htmlFor={id}
          className={classNames(
            'block text-sm font-medium leading-6 text-gray-900',
            labelClassName ? labelClassName : ''
          )}
        >
          {label}
        </Text>
      ) : (
        ''
      )}
      <input
        type={type}
        name={name}
        id={id}
        className={classNames(inputClassName ? inputClassName : '')}
        placeholder={placeholder}
      />
      {errorMessage && (
        <Text type={'error'} className={'error mt-2'}>
          {errorMessage}
        </Text>
      )}
    </div>
  );
};
